/**
 * Legacy class names kept on React markup only because CMS-authored content
 * carries `<style>` blocks that target them: editors wrote page-specific CSS
 * against the pre-CSS-Modules class names. No stylesheet in this repo styles
 * these names. Remove a hook once the content that targets it has been
 * rewritten; `grep cmsStyleHook(` lists every one. Tracked under #34988 (T5.7).
 */
export const cmsStyleHook = (legacyClassName: string): string =>
    legacyClassName;
